import type { CollegeCourseItem } from "@zrt-ai-office/types/course"
import { BootcampCard } from "./bootcamp-card"
import "./course-grid.less"

interface CourseGridProps {
  courses: CollegeCourseItem[]
  onCourseClick: (id: number) => void
}

/**
 * 临时、可撤销：已上架课程优先展示，待上架课程保持原顺序自动后置。
 * 恢复接口原始顺序时，直接改回渲染 courses 即可。
 */
function prioritizeAvailableCourses(courses: CollegeCourseItem[]) {
  const availableCourses = courses.filter((course) => course.status !== 0)
  const pendingCourses = courses.filter((course) => course.status === 0)

  return [...availableCourses, ...pendingCourses]
}

/**
 * CourseGrid -- 统一普通卡片网格（3 列），所有课程渲染为标准卡片。
 */
export function CourseGrid({ courses, onCourseClick }: CourseGridProps) {
  if (courses.length === 0) {
    return (
      <p className="course-grid__empty">
        暂无课程数据
      </p>
    )
  }

  return (
    <div className="course-grid">
      {prioritizeAvailableCourses(courses).map((course) => (
        <BootcampCard
          key={course.id}
          course={course}
          onClick={onCourseClick}
        />
      ))}
    </div>
  )
}
